import { IoArrowForwardSharp } from 'react-icons/io5';
import { Link } from 'react-router-dom';
import './Banner.css';

const NewBanner = () => {
  return (
    <section className='hero-banner relative'>
      <div className='mx-auto px-4 sm:px-6 container lg:px-8'>
        <div className='relative'>
          <div className='w-full lg:w-1/2'>
            <div className='content-box'>
              <h2 className='hero-title'>
                Hands-On Welding Training for Confident Careers & International
                Jobs
              </h2>
              <p className='hero1-content__desc'>
                M. Solaiman Technical Training Center delivers practical skills
                for confident local and global careers. Learn hands-on welding,
                1G to 4G, 4G to 6G + TIG, 1G to TIG, 1G to 6G + MIG, Pipe
                Fitter, and Shuttering Carpenter from experienced instructors
              </p>
              <div className='flex items-center gap-5 flex-wrap'>
                <Link to='/courses' className='primary-btn'>
                  Find The Course
                  <IoArrowForwardSharp className='ml-2' />
                </Link>
                <Link to='/contact' className='primary-btn second-btn'>
                  Contact Us <IoArrowForwardSharp className='ml-2' />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NewBanner;
